import { CONNECTIVE_PACKAGE_REFERENCE, CONNECTIVE_STATUS_KEY, CONNECTIVE_SUCCESSFULL_STATUSES } from "../constants";

export const getSuccessfullPackageId = (search: { [x: string]: string }) => {
    if (
        CONNECTIVE_STATUS_KEY in search &&
        CONNECTIVE_PACKAGE_REFERENCE in search &&
        CONNECTIVE_SUCCESSFULL_STATUSES.indexOf(search[CONNECTIVE_STATUS_KEY]) !== -1
    ) {
        return search[CONNECTIVE_PACKAGE_REFERENCE];
    }
};
